import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import pageHero from './pageHero';

// flarum/tags' page component, patched when the tags bundle registers it.
const TAGS_PAGE = 'ext:flarum/tags/forum/components/TagsPage';
/** Depth-first search through a vnode tree for an element with the given class. */
function findByClass(node, className) {
  if (!node || typeof node !== 'object') return null;
  const vnode = node;
  if (typeof vnode.attrs?.className === 'string' && vnode.attrs.className.split(' ').includes(className)) return vnode;
  const children = Array.isArray(node) ? node : vnode.children;
  if (Array.isArray(children)) {
    for (const child of children) {
      const found = findByClass(child, className);
      if (found) return found;
    }
  }
  return null;
}

/**
 * The /tags page: its own hero (the welcome hero it borrows can be
 * dismissed, leaving the page headless), a discussion count on each tile,
 * and a heading over the cloud of secondary tags (BimmerDock's chassis codes).
 */
export default function tagsPage() {
  override(TAGS_PAGE, 'hero', function () {
    return pageHero(app.translator.trans('flarum-tags.forum.index.tags_link'), app.translator.trans('bimmerdock-theme.forum.tags_page.subtitle'));
  });
  extend(TAGS_PAGE, 'tagTileView', function (vnode, tag) {
    const heading = findByClass(vnode, 'TagTile-heading');
    const count = tag?.discussionCount?.();
    if (!heading || !Array.isArray(heading.children) || typeof count !== 'number') return;
    heading.children.push(m("span", {
      className: "BdTagTile-count",
      title: app.translator.trans('bimmerdock-theme.forum.tags_page.discussion_count', {
        count
      }, true)
    }, m(Icon, {
      name: "far fa-comments"
    }), count));
  });
  extend(TAGS_PAGE, 'contentItems', function (items) {
    if (!items.has('cloud')) return;
    items.add('bdCloudTitle', m("h2", {
      className: "BdTagsSection-title"
    }, m(Icon, {
      name: "fas fa-car-side"
    }), app.translator.trans('bimmerdock-theme.forum.tags_page.models_title')), 11);
  });
}